import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStatusBar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <rect
      width={100.97}
      height={37.864}
      x={19.072}
      y={36.598}
      fill="#E2E2EB"
      rx={12.341}
    />
    <path
      fill="url(#Status_Bar_svg__a)"
      d="M17.95 234.051v-62.418c23.277 2.311 81.258-2.774 126.965-41.612s107.92-48.547 133.313-48.547V234.05z"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M278.229 81.473a8.976 8.976 0 0 0-8.976-8.975c-29.291 0-50.747 4.383-71.254 13.377-19.985 8.765-38.78 21.817-62.535 38.315l-.572.396c-46.772 32.481-85.318 37.663-107.967 37.663a8.975 8.975 0 1 0 0 17.95c25.817 0 68.048-6.037 118.206-40.869 24.44-16.972 41.854-29.024 60.077-37.016 17.862-7.834 36.793-11.866 64.045-11.866a8.976 8.976 0 0 0 8.976-8.975"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      d="M146.894 47.457c1.027-1.556 3.31-1.556 4.337 0l8.289 12.563c1.14 1.728-.099 4.03-2.168 4.03h-16.579c-2.069 0-3.308-2.302-2.168-4.03z"
    />
    <defs>
      <linearGradient
        id="Status_Bar_svg__a"
        x1={141.892}
        x2={141.892}
        y1={164.697}
        y2={254.856}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F6F6F9" />
        <stop offset={1} stopColor="#EEEEF3" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgStatusBar;
